// extracted by mini-css-extract-plugin
export default {"root":"IconDescription_root__gQXip"};